import AdminNewSidebar from "components/admin/AdminNewSidebar";
import React, { useState, useEffect } from "react";
import { Box, Container } from "@mui/material";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import { Table, Button, Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import apis from "../../services";
import { setAdmin } from "redux/slices/adminSlice";
import { useDispatch } from "react-redux";
import { removeHTMLTags } from "utils/removeHTMLTags";

export default function DonationShareTransfer() {
  const lang = localStorage.getItem("i18nextLng") || "sp";
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    walletId: "",
    type: "donation1",
    share: "",
    memo: "",
    id: "",
    totalShares: "",
  });

  const [stores, setStores] = useState([]);
  const [loadingStore, setLoadingStore] = useState(false);

  const onChangeHandler = (e) => {
    const { id, value } = e.currentTarget;
    setData((prevState) => ({ ...prevState, [id]: value }));
  };
  const submitHandler = async (event) => {
    event.preventDefault();
    if (data?.id) {
      setLoading(true);
      try {
        const response = await apis.transferShares(data);
        if (response?.status) {
          toast.success(response?.data?.message);
          await fetchAllStores();
          dispatch(setAdmin(response?.data?.admin));
          setData({
            walletId: "",
            type: "donation1",
            share: "",
            memo: "",
          });
        }

        setLoading(false);
      } catch (e) {
        setLoading(false);
        toast.error(e.response?.data?.message);

        console.log(`Error in Share Transfer`, e);
      }
    } else {
      setLoading(false);
      toast.error("Please select the store");
    }
  };
  const fetchAllStores = async () => {
    setLoadingStore(true);
    try {
      const res = await apis.getAllActiveStores();
      setStores(res?.data?.stores);
    } finally {
      setLoadingStore(false);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchAllStores();
    })();
  }, []);
  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loadingStore ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container
                sx={{ mt: 4, mb: 4, pb: 4 }}
                className="mainContainerComp"
              >
                <div
                  className="p-3"
                  style={{
                    border: "1px solid #E0221E",
                    borderRadius: "30px",
                    position: "relative",
                    zIndex: "10",
                  }}
                >
                  <h3 className="text-center">Donation And Share Transfer </h3>
                  <Form onSubmit={submitHandler}>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group className="mb-3" controlId="state">
                          <Form.Label>Wallet Type</Form.Label>
                          <Form.Select
                            id="type"
                            onChange={onChangeHandler}
                            required
                            value={data.type}
                          >
                            <option disabled>Select Wallet Type</option>
                            <option value={"donation1"}>Donation 1</option>
                            <option value={"donation2"}>Donation 2</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6}>
                        <Form.Group className="mb-3" controlId="formGroupEmail">
                          <Form.Label>Investor Wallet ID</Form.Label>
                          <Form.Control
                            type="string"
                            id="walletId"
                            value={data.walletId}
                            placeholder="Enter Investor Wallet ID"
                            onChange={onChangeHandler}
                            maxLength={24}
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Form.Group className="mb-3" controlId="formGroupEmail">
                        <Form.Label>
                          How much share you want to give?
                        </Form.Label>
                        <Form.Control
                          type="number"
                          id="share"
                          value={data.share}
                          placeholder="Enter Share"
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>

                      <Table responsive bordered hover size="sm">
                        <thead className="table-head">
                          <tr>
                            <th>Image</th>
                            <th>Name</th>
                            {/* <th>Shares</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="table-body">
                          {stores.length > 0 ? (
                            stores
                              .filter((item) => item.active === true)
                              .map((item, i) => {
                                return (
                                  <>
                                    <tr
                                      key={item.id}
                                      style={{ textAlign: "center" }}
                                    >
                                      <td>
                                        {" "}
                                        <img
                                          src={item?.image}
                                          width={"41px"}
                                          height={"41px"}
                                          alt="image"
                                        />
                                      </td>
                                      <td>
                                        {removeHTMLTags(
                                          lang === "en"
                                            ? item?.title_en
                                            : item?.title_sp
                                        )}
                                      </td>

                                      {/* <td>{item?.totalShares}</td> */}
                                      <td>
                                        <input
                                          style={{ marginTop: "12px" }}
                                          type="checkbox"
                                          onClick={() =>
                                            setData((prevState) => ({
                                              ...prevState,
                                              id: item?._id,
                                              totalShares: item?.totalShares,
                                            }))
                                          }
                                          checked={item?._id === data?.id}
                                        ></input>
                                      </td>
                                    </tr>
                                  </>
                                );
                              })
                          ) : (
                            <tr style={{ textAlign: "center" }}>
                              <td colSpan={7}>No Stores</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>

                      <Form.Group className="mb-3" controlId="memo">
                        <Form.Label>Memo (Optional)</Form.Label>
                        <Form.Control
                          as="textarea"
                          id="memo"
                          placeholder="Enter Memo"
                          onChange={onChangeHandler}
                          value={data.memo}
                        />
                      </Form.Group>

                      <div className="d-flex justify-content-center">
                        <Button
                          disabled={loading}
                          className="w-50"
                          variant="outline-danger"
                          type="submit"
                          style={{ maxWidth: "460px" }}
                        >
                          {loading ? "Loading" : "Send"}
                        </Button>
                      </div>
                    </Row>
                  </Form>
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-79px",
                      left: "-25px",
                      width: "296px",
                      zIndex: "-1",
                    }}
                    className="card-bg-img"
                  />
                </div>
              </Container>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
}
